module.exports = __webpack_public_path__ + "static/media/declaration.b3b89a59.png";